import React from 'react';
import PropTypes from 'prop-types';
import { LuAward, LuBookOpen, LuBuilding2, LuIdCard, LuInfo, LuMail, LuMapPin, LuPhone, LuStethoscope, LuUserPen } from 'react-icons/lu';
import DetailPane from '../../../components/data/DetailPane';
import useExternalPersonnelText from '../externalPersonnelText';
import { statusOf } from '../externalPersonnelColumns';
import { PersonnelStatusBadge, STATUS_GRADIENT, initialsOf } from './PersonnelCell';

/** The selected external personnel: "Düzenle" and every field of the record. */
const PersonnelDetailPane = ({ docked, height, personnel, position, onPrev, onNext, onClose, onEdit }) => {
  const { label, fieldLabel } = useExternalPersonnelText();
  const paneLabel = label('panel.label');

  if (!personnel) return <DetailPane docked={docked} height={height} open={false} label={paneLabel} onClose={onClose} />;

  const field = (key, icon, extra = {}) => ({ key, icon, label: fieldLabel(key), value: personnel[key] ? String(personnel[key]) : '-', ...extra });

  return (
    <DetailPane
      docked={docked}
      height={height}
      open
      label={paneLabel}
      heading={label('panel.heading')}
      position={position}
      contentKey={personnel.id}
      identity={{
        avatar: initialsOf(personnel),
        gradient: STATUS_GRADIENT[statusOf(personnel['Durum'])],
        title: `${personnel['Adı'] || ''} ${personnel['Soyadı'] || ''}`.trim() || '-',
        subtitle: [personnel['Ünvan'], personnel['Kurum']].filter(Boolean).join(' · ') || undefined,
        badges: <PersonnelStatusBadge value={personnel['Durum']} />,
      }}
      actions={[
        { key: 'edit', label: label('panel.edit'), icon: LuUserPen, tint: 'violet', onClick: onEdit },
      ]}
      details={[
        field('Telefon', LuPhone, { href: personnel['Telefon'] ? `tel:${personnel['Telefon']}` : undefined, copyable: Boolean(personnel['Telefon']) }),
        field('E-Posta', LuMail, { href: personnel['E-Posta'] ? `mailto:${personnel['E-Posta']}` : undefined, copyable: Boolean(personnel['E-Posta']) }),
        field('Kurum', LuBuilding2),
        field('Ünvan', LuAward),
        field('Uzmanlık', LuStethoscope),
        field('Ana Bilim Dalı', LuBookOpen),
        field('Personel Tipi', LuIdCard),
        field('Adres', LuMapPin),
        field('Bilgi', LuInfo),
      ]}
      onPrev={onPrev}
      onNext={onNext}
      onClose={onClose}
    />
  );
};

PersonnelDetailPane.propTypes = {
  docked: PropTypes.bool,
  height: PropTypes.number,
  personnel: PropTypes.object,
  position: PropTypes.shape({ index: PropTypes.number, total: PropTypes.number }),
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default PersonnelDetailPane;
